import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Table, Container, Card } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';


const SchemeTable = () => {
    const [schemasList,setSchemasList]=useState([]);
    const [loader,setLoader]=useState(true)

    useEffect(()=>{
    getSchemasReceivablesList();
    },[]);

    const getSchemasReceivablesList=async ()=>{
        let response= await axios('https://mis-api.happimobiles.com/api/schemes/getSchemeReceivables');
        let result=await response.data;
        setSchemasList(result)
        setLoader(false)
        console.log("result",result)

    }

const exportToCSV = (data, filename = 'data.csv') => {
  // Extract headers
  const headers = Object.keys(data[0]).join(',');

  // Extract rows
  const rows = data.map(row => Object.values(row).join(',')).join('\n');

  // Combine headers and rows
  const csvContent = `${headers}\n${rows}`;

  // Create a Blob from the CSV
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  // Create a download link
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



  return (
    <Container className="my-4">
  <Card className="shadow-lg p-4 rounded-4 border-0">
    <h3 className="mb-4 text-center fw-bold text-primary">📊 Scheme Receivables</h3>

    <div className="d-flex justify-content-end mb-3">
      <button
        className="btn btn-danger shadow-sm d-flex align-items-center gap-2"
        onClick={() => exportToCSV(schemasList)}
        disabled={schemasList.length === 0}
      >
        <i className="bi bi-file-earmark-arrow-down"></i> Export CSV
      </button>
    </div>

    {loader ? (
      <div className="d-flex justify-content-center my-5">
        <Spinner animation="border" variant="primary" />
      </div>
    ) : (
      <div className="table-responsive">
        <Table bordered hover className="align-middle shadow-sm">
          <thead className="table-primary text-center">
            <tr>
              <th>Brand Name</th>
              <th>Item Name</th>
              <th>Scheme</th>
              <th>From Date</th>
              <th className="text-nowrap">To Date</th>
              <th>FTD Sale Quantity</th>
              <th>MTD Sale Quantity</th>
              <th>Sell Discount Percentage</th>
            <th>Sell Discount Value</th>
              <th>Sellout Spike/Qty</th>
              <th>Sellout Spike</th>
              <th>Sellout Total</th>
            </tr>
          </thead>
          <tbody>
            {schemasList.map((item, index) => (
              <tr key={index} className="text-center">
                <td>{item?.brand_name}</td>
                <td>{item?.item_name}</td>
                <td>{item?.scheme}</td>
                <td>{moment(item?.from_date).format("DD-MM-YY")}</td>
                <td>{moment(item?.to_date).format("DD-MM-YY")}</td>
                <td>{item.ftd_qty}</td>
                <td>{item.mtd_qty}</td>
                <td>{item.sellout_disc_pct}</td>
                <td>{item.sellout_disc_value}</td>
                <td>{item.sellout_spike_each_qty}</td>
                <td>{item.sellout_spike}</td>
                <td>{item.sellout_total}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    )}
  </Card>
</Container>
  );
};

export default SchemeTable;
